import RemoteResiliencePlugin from '@tn/foundation/federation-plugins/remote-resilience-plugin';
module.exports = RemoteResiliencePlugin;
